import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "../../theme";
import { 
    Box, Container, Table, TableBody, TableCell, TableHead, TableRow, Button, 
    Grid, Card, CardContent, Typography, Chip, Pagination, TextField, InputAdornment, 
    IconButton, CircularProgress, TableContainer, Stack
} from "@mui/material";
import axios from "axios";
import { useEffect, useState, useRef, useCallback } from "react";
import swal from "sweetalert";
import { io } from "socket.io-client";
import { Search as SearchIcon, CasinoOutlined, RefreshOutlined } from '@mui/icons-material';

import xx1 from "../../static/txmd5/xx1_1.png";
import xx2 from "../../static/txmd5/xx2_1.png";
import xx3 from "../../static/txmd5/xx3_1.png";
import xx4 from "../../static/txmd5/xx4_1.png";
import xx5 from "../../static/txmd5/xx5_1.png";
import xx6 from "../../static/txmd5/xx6_1.png";

const diceImages = { 1: xx1, 2: xx2, 3: xx3, 4: xx4, 5: xx5, 6: xx6 };
const SERVER_URL = "https://server.vz88.vin"; 

// ==========================================
// THEME CHUẨN METRONIC
// ==========================================
const metronicTheme = createTheme({
    palette: {
        background: { default: "#F5F8FA", paper: "#FFFFFF" }, 
        text: { primary: "#181C32", secondary: "#7E8299" }, 
        primary: { main: "#1B84FF", light: "#F1FAFF" },
        success: { main: "#50CD89", light: "#E8FFF3" },
        danger: { main: "#F1416C", light: "#FFF5F8" },
        warning: { main: "#FFC700", light: "#FFF8DD" },
        dark: { main: "#181C32" } // Dành cho bên Tài
    },
    typography: { fontFamily: "'Plus Jakarta Sans', sans-serif" },
    components: {
        MuiCard: { styleOverrides: { root: { borderRadius: "12px", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.03)", border: "1px solid #E4E6EF" } } },
        MuiTableCell: { styleOverrides: { root: { borderBottom: "1px dashed #EFF2F5 !important", padding: "12px 16px", color: "#3F4254", fontSize: "0.85rem", fontFamily: "'Plus Jakarta Sans', sans-serif !important" } } },
        MuiButton: { styleOverrides: { root: { fontFamily: "'Plus Jakarta Sans', sans-serif", textTransform: 'none', fontWeight: 700, borderRadius: '8px' } } }
    }
});

function SetTXMD5() {
    // State Game
    const [rawTime, setRawTime] = useState(0);
    const [displayTime, setDisplayTime] = useState(0);
    const [gameState, setGameState] = useState("");
    const [phien, setPhien] = useState("...");
    const [result, setResult] = useState("...");

    // State Realtime
    const [totalMoneyTai, setTotalMoneyTai] = useState(0);
    const [totalMoneyXiu, setTotalMoneyXiu] = useState(0);
    const [totalUserTai, setTotalUserTai] = useState(0);
    const [totalUserXiu, setTotalUserXiu] = useState(0);
    const [usersTai, setUsersTai] = useState([]);
    const [usersXiu, setUsersXiu] = useState([]);

    // State Admin
    const [adminSettingMsg, setAdminSettingMsg] = useState(null);
    const [selectedDice, setSelectedDice] = useState([]); 
    
    // State Lịch sử
    const [listSessionHistory, setListSessionHistory] = useState([]); 
    const [listPlayerHistory, setListPlayerHistory] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchKeyword, setSearchKeyword] = useState("");
    const [isLoadingHistory, setIsLoadingHistory] = useState(false);

    const socketRef = useRef();

    useEffect(() => {
        socketRef.current = io(SERVER_URL);

        // Lắng nghe thời gian và vé cược realtime
        socketRef.current.on("tx_time", (data) => {
            const serverTime = data.time;
            setRawTime(serverTime);

            if (serverTime > 15) {
                setDisplayTime(serverTime - 15);
                setGameState("ĐANG ĐẶT CƯỢC");
            } else {
                setDisplayTime(serverTime);
                setGameState("TRẢ THƯỞNG / MỞ BÁT");
            }

            if (data.data) setPhien(data.data.id_bet);

            if (data.lists) {
                const listTai = data.lists.tai || [];
                const listXiu = data.lists.xiu || [];
                setUsersTai(listTai);
                setUsersXiu(listXiu);
                setTotalMoneyTai(listTai.reduce((sum, item) => sum + Number(item.money), 0));
                setTotalMoneyXiu(listXiu.reduce((sum, item) => sum + Number(item.money), 0));
                setTotalUserTai(listTai.length);
                setTotalUserXiu(listXiu.length);
            }

            setAdminSettingMsg(data.admin_setting || null);
        });

        // Lắng nghe khi có kết quả
        socketRef.current.on("tx_result", (data) => {
            setResult(data.result);
            fetchHistorySession();
            setAdminSettingMsg(null);
            setSelectedDice([]); 
        });

        // Lắng nghe khi sang phiên mới
        socketRef.current.on("tx_new_session", (data) => {
            setPhien(data.id_bet);
            setResult("...");
            setTotalMoneyTai(0); setTotalMoneyXiu(0);
            setTotalUserTai(0); setTotalUserXiu(0);
            setUsersTai([]); setUsersXiu([]);
            setAdminSettingMsg(null);
            setSelectedDice([]); 
        });

        fetchHistorySession();
        fetchPlayerHistory(1, "", false); 

        return () => {
            if (socketRef.current) socketRef.current.disconnect();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // HÀM GET DỮ LIỆU NGƯỜI CHƠI
    const fetchPlayerHistory = useCallback((pageNum, keyword, isSilent = false) => {
        if (!isSilent) setIsLoadingHistory(true); 
        const query = keyword ? `&username=${keyword}` : "";
        axios.get(`${SERVER_URL}/taixiumd560s/history-all-players?page=${pageNum}&limit=10${query}`)
            .then((res) => {
                if (res.data.success) {
                    setListPlayerHistory(res.data.data);
                    setTotalPages(res.data.totalPages || 1);
                    setPage(pageNum);
                }
            })
            .catch((err) => console.log(err))
            .finally(() => {
                if (!isSilent) setIsLoadingHistory(false);
            });
    }, []);

    // AUTO UPDATE MỖI 3 GIÂY
    useEffect(() => {
        const silentUpdateTimer = setInterval(() => {
            fetchPlayerHistory(page, searchKeyword, true); 
        }, 3000);
        return () => clearInterval(silentUpdateTimer);
    }, [page, searchKeyword, fetchPlayerHistory]);

    // Hàm lấy lịch sử cầu
    const fetchHistorySession = () => {
        axios.get(`${SERVER_URL}/taixiumd560s/getallbet?limit=20`).then((res) => {
            if (res.data.success) {
                const filteredData = res.data.data.filter(item => item.result);
                setListSessionHistory(filteredData.slice(0, 20)); 
            }
        }).catch(() => {});
    };

    const handleSearch = () => { setPage(1); fetchPlayerHistory(1, searchKeyword, false); };

    // --- CÁC HÀM XỬ LÝ KHÁC ---
    const handleSelectDice = (val) => {
        if (selectedDice.length >= 3) return swal("Thông báo", "Tối đa 3 viên!", "warning");
        setSelectedDice([...selectedDice, val]);
    };
    const handleResetDice = () => {
        setSelectedDice([]);
        if(rawTime > 16) axios.get(`${SERVER_URL}/api/set-result/clear`);
    };
    const submitDiceResult = async () => {
        if (rawTime <= 16) return swal("Hết giờ!", "Đã quá thời gian chỉnh cầu", "warning");
        if (selectedDice.length !== 3) return swal("Chưa đủ", "Vui lòng chọn 3 viên", "warning");
        try {
            const res = await axios.get(`${SERVER_URL}/api/set-dice/${selectedDice[0]}/${selectedDice[1]}/${selectedDice[2]}`);
            if (res.data.success) swal("Thành công", res.data.message, "success");
        } catch (error) {}
    };
    const setTaiXiuRandom = async (side) => {
        if (rawTime <= 16 && side !== "clear") return swal("Hết giờ!", "Đã quá thời gian", "warning");
        if(side === "clear") {
            try {
                await axios.get(`${SERVER_URL}/api/set-result/clear`);
                setSelectedDice([]);
                swal("Đã Hủy", "Chạy ngẫu nhiên", "success");
            } catch (e) {}
            return;
        }
        try {
            const res = await axios.get(`${SERVER_URL}/api/set-result/${side}`);
            if (res.data.success) {
                if(res.data.dice) setSelectedDice(res.data.dice);
                swal("Thành công", res.data.message, "success");
            }
        } catch (error) {}
    };
    
    const formatMoney = (n) => String(n ? n : 0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    // CSS Table Head dùng chung
    const tableHeadSx = { color: "#A1A5B7 !important", fontWeight: "800 !important", fontSize: "0.75rem !important", backgroundColor: "#FFFFFF !important", borderBottom: "2px solid #EFF2F5 !important", textTransform: "uppercase !important", whiteSpace: "nowrap" };

    const UserListTable = ({ users, title, color }) => (
        <Box sx={{ maxHeight: 300, overflow: 'auto', border: `1px solid #EFF2F5`, borderRadius: '0 0 8px 8px' }}>
            <Table size="small" stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ fontWeight: '800', color: color, bgcolor: '#F9F9F9', fontSize: '13px' }}>USER ({users.length})</TableCell>
                        <TableCell sx={{ fontWeight: '800', color: color, textAlign: 'right', bgcolor: '#F9F9F9', fontSize: '13px' }}>TIỀN CƯỢC</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {users && users.length > 0 ? (
                        users.map((u, i) => (
                            <TableRow key={i} hover>
                                <TableCell sx={{ fontWeight: '700', color: '#1B84FF' }}>{u.user?.username || "Ẩn danh"}</TableCell>
                                <TableCell align="right" sx={{ fontWeight: '800', color: '#181C32' }}>{formatMoney(u.money)} đ</TableCell>
                            </TableRow>
                        ))
                    ) : (
                        <TableRow><TableCell colSpan={2} align="center" sx={{ color: '#A1A5B7', py: 3, fontWeight: 600 }}>Trống</TableCell></TableRow>
                    )}
                </TableBody>
            </Table>
        </Box>
    );

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <ThemeProvider theme={metronicTheme}>
                    <style>{`
                        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
                        .safe-tx-zone * { font-family: 'Plus Jakarta Sans', sans-serif !important; text-align: left; }
                    `}</style>

                    <Box className="safe-tx-zone" component="main" sx={{ flexGrow: 1, py: 4, bgcolor: '#F5F8FA', minHeight: '100vh' }}>
                        <Container maxWidth="xl">
                            
                            {/* HEADER */}
                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={4} flexWrap="wrap" gap={2}>
                                <Box display="flex" alignItems="center" gap={1.5}>
                                    <CasinoOutlined sx={{ fontSize: '2.5rem', color: '#10B981' }} />
                                    <Box>
                                        <Typography variant="h4" fontWeight="800" color="#181C32">Tài Xỉu MD5</Typography>
                                        <Typography variant="body2" color="text.secondary" fontWeight="500">Quản trị kết quả & Báo cáo cược Real-time</Typography>
                                    </Box>
                                </Box>
                                <Button variant="outlined" color="primary" startIcon={<RefreshOutlined />} onClick={() => window.location.reload()}>
                                    Làm mới
                                </Button>
                            </Box>

                            {/* --- 1. THÔNG TIN PHIÊN & CHỌN KẾT QUẢ --- */}
                            <Grid container spacing={3} sx={{mb: 4}}>
                                {/* Cột Thông Tin Phiên */}
                                <Grid item xs={12} md={6}>
                                    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                        <CardContent sx={{ p: 4 }}>
                                            <Grid container spacing={2} alignItems="center">
                                                <Grid item xs={6} style={{ textAlign: 'center', borderRight: '1px dashed #EFF2F5' }}>
                                                    <Typography variant="caption" fontWeight="800" color="text.secondary">PHIÊN HIỆN TẠI</Typography>
                                                    <Typography variant="h5" color="primary" sx={{ fontWeight: '900', mb: 1 }}>#{phien}</Typography>
                                                    <Box sx={{ 
                                                        fontSize: '60px', fontWeight: '900', 
                                                        color: rawTime <= 15 ? '#F1416C' : '#50CD89', 
                                                        lineHeight: 1, mb: 1 
                                                    }}>
                                                        {displayTime}
                                                    </Box>
                                                    <Chip label={gameState} size="small" sx={{ fontWeight: 800, backgroundColor: rawTime <= 15 ? '#FFF5F8' : '#E8FFF3', color: rawTime <= 15 ? '#F1416C' : '#50CD89' }}/>
                                                    {adminSettingMsg && <Box mt={1}><Chip label={adminSettingMsg} color="warning" size="small" sx={{fontWeight: 800}} /></Box>}
                                                </Grid>
                                                <Grid item xs={6} style={{ textAlign: 'center' }}>
                                                    <Typography variant="caption" fontWeight="800" color="text.secondary">KẾT QUẢ PHIÊN</Typography>
                                                    <Typography variant="h3" sx={{ fontWeight: '900', color: '#181C32', mt: 2 }}>{result}</Typography>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                
                                {/* Cột Chọn Kết quả */}
                                <Grid item xs={12} md={6}>
                                    <Card sx={{ border: '2px solid #50CD89', height: '100%' }}>
                                        <CardContent sx={{ p: 4, display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'center' }}>
                                            <Typography variant="subtitle1" align="center" sx={{ fontWeight: '800', color: '#50CD89', mb: 2 }}>🎯 CAN THIỆP KẾT QUẢ</Typography>
                                            <Grid container spacing={2} justifyContent="center" alignItems="center" mb={2}>
                                                {[1, 2, 3, 4, 5, 6].map((val) => {
                                                    const isSelected = selectedDice.includes(val);
                                                    const count = selectedDice.filter(x => x === val).length;
                                                    return (
                                                        <Grid item key={val} style={{position: 'relative'}}>
                                                            <img 
                                                                src={diceImages[val]} alt={`Dice ${val}`} onClick={() => handleSelectDice(val)}
                                                                style={{ 
                                                                    width: '55px', cursor: 'pointer', borderRadius: '12px', 
                                                                    boxShadow: isSelected ? '0 0 0 3px #50CD89' : '0 4px 6px rgba(0,0,0,0.1)',
                                                                    transform: isSelected ? 'scale(1.1)' : 'scale(1)',
                                                                    transition: 'all 0.2s ease'
                                                                }}
                                                            />
                                                            {count > 0 && <Box sx={{position: 'absolute', top: -8, right: -8, background: '#F1416C', color: 'white', borderRadius: '50%', width: 22, height: 22, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 800, border: '2px solid #fff'}}>{count}</Box>}
                                                        </Grid>
                                                    );
                                                })}
                                            </Grid>
                                            
                                            <Box sx={{ minHeight: '30px', textAlign: 'center' }}>
                                                {selectedDice.length > 0 ? (
                                                    <Typography align="center" sx={{ fontWeight:'800', color: '#181C32' }}>
                                                        Dự kiến: {selectedDice.join(" - ")} (Tổng: {selectedDice.reduce((a,b)=>a+b,0)} - <span style={{color: selectedDice.reduce((a,b)=>a+b,0) > 10 ? '#181C32' : '#F1416C'}}>{selectedDice.reduce((a,b)=>a+b,0) > 10 ? "TÀI" : "XỈU"}</span>)
                                                    </Typography>
                                                ) : <Typography align="center" sx={{ fontStyle:'italic', color:'#A1A5B7', fontWeight: 600 }}>Chưa chọn xúc xắc</Typography>}
                                            </Box>

                                            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', gap: 2 }}>
                                                <Button variant="outlined" color="inherit" onClick={handleResetDice} sx={{color: '#7E8299', borderColor: '#E4E6EF'}}>Xóa Lựa Chọn</Button>
                                                <Button variant="contained" color="success" onClick={submitDiceResult} disabled={rawTime <= 16} sx={{boxShadow: 'none'}}>XÁC NHẬN KẾT QUẢ</Button>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>

                            {/* --- 2. BẢNG CƯỢC TÀI XỈU --- */}
                            <Grid container spacing={3} sx={{mb: 4}}>
                                {/* Cửa TÀI */}
                                <Grid item xs={12} md={6}>
                                    <Card sx={{ bgcolor: '#FFF', borderTop: '5px solid #181C32' }}>
                                        <CardContent sx={{ p: '0 !important' }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#181C32', p: 2, borderRadius: '6px 6px 0 0', color: '#fff' }}>
                                                <Typography variant="h5" sx={{ fontWeight: '900' }}>⚫ TÀI</Typography>
                                                <Typography variant="h5" sx={{ fontWeight: '900', color: '#50CD89' }}>{formatMoney(totalMoneyTai)} đ</Typography>
                                            </Box>
                                            <UserListTable users={usersTai} title="Tài" color="#181C32" />
                                            <Box p={2}>
                                                <Button variant="contained" fullWidth onClick={() => setTaiXiuRandom("3")} disabled={rawTime <= 16} sx={{ backgroundColor: '#181C32', '&:hover': {backgroundColor: '#000'}, boxShadow: 'none' }}>
                                                    SET VỀ TÀI (Đổ Ngẫu Nhiên)
                                                </Button>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                {/* Cửa XỈU */}
                                <Grid item xs={12} md={6}>
                                    <Card sx={{ bgcolor: '#FFF', borderTop: '5px solid #F1416C' }}>
                                        <CardContent sx={{ p: '0 !important' }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#F1416C', p: 2, borderRadius: '6px 6px 0 0', color: '#fff' }}>
                                                <Typography variant="h5" sx={{ fontWeight: '900' }}>🔴 XỈU</Typography>
                                                <Typography variant="h5" sx={{ fontWeight: '900', color: '#FFC700' }}>{formatMoney(totalMoneyXiu)} đ</Typography>
                                            </Box>
                                            <UserListTable users={usersXiu} title="Xỉu" color="#F1416C" />
                                            <Box p={2}>
                                                <Button variant="contained" color="error" fullWidth onClick={() => setTaiXiuRandom("4")} disabled={rawTime <= 16} sx={{ boxShadow: 'none' }}>
                                                    SET VỀ XỈU (Đổ Ngẫu Nhiên)
                                                </Button>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                            
                            <Box sx={{ textAlign: 'center', mb: 5 }}>
                                <Button variant="outlined" color="error" onClick={() => setTaiXiuRandom("clear")} disabled={rawTime <= 16} sx={{ px: 5, py: 1.5, fontSize: '1rem', borderWidth: 2, '&:hover': {borderWidth: 2} }}>
                                    HỦY CAN THIỆP (Để Tự Nhiên)
                                </Button>
                            </Box>

                            {/* --- 3. LỊCH SỬ CƯỢC NGƯỜI CHƠI --- */}
                            <Card sx={{ mb: 4 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 3, borderBottom: '1px solid #EFF2F5' }}>
                                    <Typography variant="h6" sx={{ fontWeight: '800', color: '#181C32' }}>LỊCH SỬ CƯỢC (Real-time)</Typography>
                                    <TextField 
                                        size="small" placeholder="Tìm username..." 
                                        value={searchKeyword} onChange={(e) => setSearchKeyword(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                                        InputProps={{ 
                                            startAdornment: <InputAdornment position="start"><SearchIcon sx={{color: '#A1A5B7'}} /></InputAdornment>,
                                            sx: { borderRadius: '6px', bgcolor: '#F9F9F9' }
                                        }}
                                    />
                                </Box>
                                
                                {isLoadingHistory ? <Box sx={{ display: 'flex', justifyContent: 'center', p: 8 }}><CircularProgress /></Box> : (
                                    <TableContainer>
                                        <Table sx={{ minWidth: 800 }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{...tableHeadSx, pl: 3}}>THỜI GIAN</TableCell>
                                                    <TableCell sx={tableHeadSx}>NGƯỜI CHƠI</TableCell>
                                                    <TableCell sx={tableHeadSx}>PHIÊN</TableCell>
                                                    <TableCell align="center" sx={tableHeadSx}>CỬA ĐẶT</TableCell>
                                                    <TableCell align="right" sx={tableHeadSx}>TIỀN CƯỢC</TableCell>
                                                    <TableCell align="right" sx={{...tableHeadSx, pr: 3}}>TIỀN THẮNG</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {listPlayerHistory && listPlayerHistory.length > 0 ? listPlayerHistory.map((item) => (
                                                    <TableRow key={item._id} hover>
                                                        <TableCell sx={{ color: '#A1A5B7', fontWeight: 600, pl: 3 }}>{new Date(item.createdAt).toLocaleTimeString()}</TableCell>
                                                        <TableCell sx={{ fontWeight: '800', color: '#1B84FF' }}>{item.user ? item.user.username : '...'}</TableCell>
                                                        <TableCell sx={{ fontWeight: '700', color: '#181C32' }}>#{item.id_bet}</TableCell>
                                                        <TableCell align="center">
                                                            <Chip label={item.state === "3" ? "Tài" : "Xỉu"} size="small" sx={{ fontWeight: 800, backgroundColor: item.state === "3" ? '#F5F8FA' : '#FFF5F8', color: item.state === "3" ? '#181C32' : '#F1416C', borderRadius: '4px' }} />
                                                        </TableCell>
                                                        <TableCell align="right" sx={{ fontWeight: '800', color: '#181C32' }}>{formatMoney(item.money)} đ</TableCell>
                                                        <TableCell align="right" sx={{ fontWeight: '800', color: '#50CD89', pr: 3 }}>{item.moneythang > 0 ? `+${formatMoney(item.moneythang)} đ` : ""}</TableCell>
                                                    </TableRow>
                                                )) : <TableRow><TableCell colSpan={6} align="center" sx={{ color: '#A1A5B7', py: 6, fontWeight: 700 }}>Không tìm thấy dữ liệu</TableCell></TableRow>}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                )}
                                <Box sx={{ display: "flex", justifyContent: "flex-end", p: 2, borderTop: '1px solid #EFF2F5' }}>
                                    <Pagination count={totalPages} page={page} onChange={(e, val) => fetchPlayerHistory(val, searchKeyword, false)} color="primary" shape="rounded" sx={{ '& .MuiPaginationItem-root': { fontWeight: 700 } }} />
                                </Box>
                            </Card>

                            {/* --- 4. LỊCH SỬ PHIÊN KẾT QUẢ --- */}
                            <Card>
                                <Box sx={{ p: 3, borderBottom: '1px solid #EFF2F5' }}>
                                    <Typography variant="h6" sx={{ fontWeight: '800', color: '#181C32' }}>LỊCH SỬ PHIÊN (20 Phiên gần nhất)</Typography>
                                </Box>
                                <TableContainer>
                                    <Table sx={{ minWidth: 600 }}> 
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{...tableHeadSx, pl: 3}}>PHIÊN</TableCell>
                                                <TableCell align="center" sx={tableHeadSx}>KẾT QUẢ XÚC XẮC</TableCell>
                                                <TableCell align="center" sx={tableHeadSx}>TỔNG</TableCell>
                                                <TableCell align="right" sx={{...tableHeadSx, pr: 3}}>THỜI GIAN MỞ</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {listSessionHistory.map((item) => {
                                                const dice = item.result.split(" ").map(Number);
                                                const sum = dice.reduce((a, b) => a + b, 0);
                                                const isTai = sum > 10;
                                                return (
                                                    <TableRow key={item._id} hover>
                                                        <TableCell sx={{ fontWeight: '700', color: '#A1A5B7', pl: 3 }}>#{item.id_bet}</TableCell>
                                                        <TableCell align="center">
                                                            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                                                                {dice.map((d, k) => <img key={k} src={diceImages[d]} width="24px" alt={`dice-${d}`} style={{borderRadius: '4px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)'}} />)}
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <Chip label={`${sum} (${isTai ? 'TÀI' : 'XỈU'})`} size="small" sx={{ fontWeight: 800, backgroundColor: isTai ? '#F5F8FA' : '#FFF5F8', color: isTai ? '#181C32' : '#F1416C', borderRadius: '4px' }} />
                                                        </TableCell>
                                                        <TableCell align="right" sx={{ fontWeight: '600', color: '#7E8299', pr: 3 }}>{new Date(item.createdAt).toLocaleTimeString()}</TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Card>

                        </Container>
                    </Box>
                </ThemeProvider>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default SetTXMD5;